import React, { useState } from "react";
import { Arrow, CircleTick, GreenAlert, RedAlert, YellowAlert } from "../assets/icons";
import Button from "../components/elements/button";
import CTA from "../components/sections/cta";
import Features from "../components/sections/features";
import Hero from "../components/sections/hero";
import Testimonials from "../components/sections/testimonials";
import WHY from "../components/sections/why";
import VisitorStats from "../components/elements/visitorStats";
import step_image from "../assets/images/ai-content.jpg";
import step_image2 from "../assets/images/dr-selim-lab.jpeg";
import step_image3 from "../assets/images/research-mm-worldfishcenter.jpg";
import { useNavigate } from "react-router-dom";
import '../assets/css/pages/home.css';
import '../pages/landing/LandingPage.css';
import '../assets/css/landing.css';

const Index = () => {
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const steps = [
        {
            icon : GreenAlert,
            title: "Report the Issue",
            description: "Submit details about the health problem affecting your fish.",
            image: step_image,
            actions : ['Describe symptoms and upload images or videos.', 'Provide water quality and environmental data.', 'Select urgency level for faster assistance.']
        },
        {
            icon : YellowAlert,
            title: "AI-Powered Diagnosis & Expert Review",
            description: "Our system analyzes the case and connects you with specialists.",
            image: step_image2,
            actions : ['AI assesses symptoms for potential disease matches.', 'Veterinarians review reports and provide expert insights.', 'Receive suggested treatment plans and preventive measures.']
        },
        {
            icon : RedAlert,
            title: "Get Treatment & Prevention Guidance",
            description: "Take action to restore fish health and prevent future outbreaks.",
            image: step_image3,
            actions : ['Follow recommended treatment steps and biosecurity measures.', 'Purchase necessary medications or equipment via the marketplace.', 'Access educational resources to improve farm disease management.']
        }
    ];
    return (
      <div>
        <Hero />
        {/* Banner style visitor counter at the top */}
        <div className="stats-banner-container">
          <VisitorStats variant="banner" />
        </div>
        <WHY />
        <Features />
        {/* Add standard visitor stats before How it Works section */}
        <div className="visitor-stats-container">
          <VisitorStats variant="standard" />
        </div>
        <section className="how-section">
        <div className="how-container">
            <div className="how-header">
                <h2 className="how-title">How it Works</h2>
                <p className="how-description">Our simple process helps you get started with Case Reporting & Disease Diagnosis</p>
            </div>
    
    <div className="steps-container">
        <ul className="steps-wrapper">
            {steps.map((step, index) => (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>

                    <div className="step-number" style={{ marginTop: `${index * 25}px`}}>{index + 1}</div>
                <li
                onClick={() => {
                    setActiveStep(index);
                    const stepCards = document.querySelectorAll('.step-card');
                    stepCards.forEach(card => card.classList.remove('active'));
                    document.querySelectorAll('.step-card')[index].classList.add('active');
                }}
                    key={index}
                    className={`step-card ${index === activeStep ? 'active' : ''}`}
                    style={{ marginTop: `${index * 25}px`, listStyleType:1 }}
                >
                    <div className="step-content">
                        <img src={step.icon} alt="Setup System" className="step-icon" />
                        <h3 className="step-title">{step.title}</h3>
                        <p className="step-description">{step.description}</p>
                    </div>
                </li>
                </div>
            ))}
        </ul>
                    
                    <div className="how-grid">
                        <div className="how-image-container">
                            {/* <img src={steps[activeStep].image} alt="Setup System" className="how-image" /> */}
                            <img src={steps[activeStep].image} alt="Setup System" className="how-image" />
                        </div>
                        <div className="how-content">
                            <span className="step-label">Step {activeStep +1}</span>
                            <h3 className="step-title">{steps[activeStep].title}</h3>
                            <hr className="step-divider" />
                            <ul className="step-list">
                                {steps[activeStep].actions.map((item, i) => (
                                    <li key={i} className="step-list-item">
                                        <img src={CircleTick} alt="check" className="step-list-icon" />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                            <Button onClick={() => { navigate('/register')}} text="Sign Up Now" variant="primary" icon={<img src={Arrow} alt="" className="arrow_up" />} />

                            {/* Add minimal visitor counter in the signup area */}
                            <div className="signup-stats">
                              <VisitorStats variant="minimal" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <Testimonials />
        <CTA />
      </div>
    );
}
export default Index;